module.exports = __webpack_public_path__ + "static/img/anonymity.3f9b695.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Food/anonymity.png
// module id = uhgg
// module chunks = 1